/**
 * Auto-denominate chart values: if max value >= 1000 (millions),
 * convert all to billions and update unit label.
 * Also rounds employment values to nearest 100 (display only).
 */

export const autoDenominate = (
  values: (number | null | undefined)[],
  displayUnit: string
): { converted: (number | null)[], unit: string } => {
  const nums = values.filter((v): v is number => v != null && v !== 0);
  const maxVal = nums.length > 0 ? Math.max(...nums.map(Math.abs)) : 0;

  if (maxVal >= 1000 && displayUnit.toLowerCase().includes("million")) {
    return {
      converted: values.map(v =>
        v != null && v !== 0 ? Math.floor((v / 1000) * 10) / 10 : null
      ),
      unit: displayUnit.replace(/million/i, "billion"),
    };
  }

  return {
    converted: values.map(v => v ?? null),
    unit: displayUnit,
  };
};

export const roundJobsForDisplay = (v: number): number => {
  const rounded = Math.round(v);
  return rounded >= 1000 ? Math.round(rounded / 100) * 100 : rounded;
};
